import axios from 'axios';
import config from "../config";

const BASE_URL = `${config.apiUrl}/user`;

export default {

    accountInfo()
    {
        return axios.get(`${BASE_URL}`).then(result => result.data);
    },

    login(name, password)
    {
        return axios.post(`${BASE_URL}/login`,{name, password}).then(result => result.data);
    },

    logout()
    {
        return axios.post(`${BASE_URL}/logout`).then(result => result.data);
    },

}
